/* Boadicea animated header logo.
   Toggles .is-compact on <logo-transition> once the page scrolls past data-trigger-on (px),
   and removes it below data-trigger-off (px). The gap stops it flickering near the top.
   The scroll triggers the transition; it does not scrub it. */
if (!customElements.get('logo-transition')) {
  customElements.define('logo-transition', class LogoTransition extends HTMLElement {
    connectedCallback() {
      this.on = parseInt(this.dataset.triggerOn, 10) || 48;
      this.off = parseInt(this.dataset.triggerOff, 10) || 12;
      this.ticking = false;
      this.onScroll = this.onScroll.bind(this);

      // Set the correct state without animating if the page loads already scrolled
      this.classList.add('no-transition');
      this.update();
      requestAnimationFrame(() => requestAnimationFrame(() => this.classList.remove('no-transition')));

      window.addEventListener('scroll', this.onScroll, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => { this.update(); this.ticking = false; });
    }

    update() {
      const y = window.scrollY || document.documentElement.scrollTop;
      if (y > this.on) this.classList.add('is-compact');
      else if (y < this.off) this.classList.remove('is-compact');
    }
  });
}
